import 'core-js/es/promise';
import 'core-js/es/array/find';
import 'core-js/es/array/find-index';
import 'core-js/es/array/is-array';
import 'core-js/es/array/includes';
import 'core-js/es/number/is-nan';
import 'core-js/es/number/is-integer';
import 'core-js/es/object/assign';
import 'core-js/es/object/entries';
import 'core-js/es/string/includes';

import smoothscroll from 'smoothscroll-polyfill';

import './request-animation-polyfill';
import './element-remove';
import './node-list-for-each';

smoothscroll.polyfill();
